import './styles.css';
import { Controller } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import createCompany from '../../tools/integrations/crmRequests/createCompany';
import {
  openChatTab,
  setAddOrganizationForm,
} from '../../../store/modules/chat/actions';
import { useLocalForm } from './useLocalForm';
import { toast } from 'react-toastify';
import React, { useState } from 'react';
import { formatCnpj } from './useLocalForm/validationSchema';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import {
  Col,
  Row,
  Button,
  Container,
  FormGroup,
  Input,
  FormFeedback,
  Label,
} from '@polichat/flamboyant';

import { isMobile } from 'react-device-detect';

export default function OrganizationAddForm(props) {
  const dispatch = useDispatch();
  const form = useLocalForm();

  const [cnpjValue, setCnpjValue] = useState('');

  // Traduções
  const nameText = useGlotaT('spa.admin.companies.name');
  const cnpjText = useGlotaT('spa.admin.companies.cnpj');
  const companyNameText = useGlotaT('spa.admin.companies.companyName');
  const siteText = useGlotaT('spa.admin.companies.site');
  const emailText = useGlotaT('spa.admin.companies.email');
  const typeText = useGlotaT('spa.admin.companies.type');
  const addressText = useGlotaT('spa.admin.companies.address');
  const observationsText = useGlotaT('spa.admin.companies.observations');
  const cancelText = useGlotaT('spa.admin.companies.cancel');
  const saveText = useGlotaT('spa.admin.companies.save');
  const registrationCompletedText = useGlotaT('spa.admin.companies.registrationCompleted');
  const duplicatedCnpjText = useGlotaT('spa.admin.companies.duplicatedCnpj');
  const errorSavingCompanyText = useGlotaT('spa.admin.companies.errorSavingCompany');
  const activeClientText = useGlotaT('spa.admin.companies.activeClient');
  const inactiveClientText = useGlotaT('spa.admin.companies.inactiveClient');
  const providerText = useGlotaT('spa.admin.companies.provider');

  const typeOptions = {
    '': '',
    active: activeClientText,
    inactive: inactiveClientText,
    provider: providerText,
  };

  async function verifyCompanyAtBase(data) {
    try {
      const response = await createCompany(data);

      if (response) {
        toast.success(
          <div style={{ margin: 0 }}>
            <span>{registrationCompletedText}</span>
            {response && (
              <>
                <br />
              </>
            )}
          </div>
        );
        return true;
      }
    } catch (error) {
      if(error?.response?.data?.error === "Duplicated CNPJ"){
        toast.error(          
          duplicatedCnpjText
        );
      }else{
        toast.error(
          error?.response?.data?.error ||
            errorSavingCompanyText
        );
      }
    }
    return false;
  }

  const onSubmit = async (values) => {
    try {
      let toast = await verifyCompanyAtBase(values);
      if (toast) {
        setIsLoading(true);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <Container className={'createForm'}>
        <Row form>
          <Col lg={12}>
            <FormGroup>
              <Label for="name">{nameText}:</Label>
              <Controller
                control={form.control}
                name="name"
                render={({ field, fieldState }) => (
                  <>
                    <Input
                      InputLabelProps={{ shrink: true }}
                      type="text"
                      label="name"
                      variant="outlined"
                      margin="normal"
                      {...field}
                      invalid={!!fieldState.error}
                    />
                    <FormFeedback>{fieldState.error?.message}</FormFeedback>
                  </>
                )}
              />
            </FormGroup>
          </Col>
          <Col lg={6}>
            <FormGroup>
            <Label for="cnpj">{cnpjText}:</Label>
            <Controller
              control={form.control}
              name="cnpj"
              render={({ field, fieldState }) => (
                <>
                  <Input
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="cnpj"
                    variant="outlined"
                    margin="normal"
                    value={cnpjValue}
                    onChange={(e) => {
                      const formattedValue = formatCnpj(e.target.value);
                      setCnpjValue(formattedValue);
                      field.onChange(formattedValue);
                    }}
                    invalid={!!fieldState.error}
                  />
                    <FormFeedback>{fieldState.error?.message}</FormFeedback>
                  </>
                )}
              />
            </FormGroup>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <Label for="companyName">{companyNameText}:</Label>
              <Controller
                control={form.control}
                name="companyName"
                render={({ field, fieldState }) => (
                  <>
                    <Input
                      InputLabelProps={{ shrink: true }}
                      type="text"
                      label="companyName"
                      variant="outlined"
                      margin="normal"
                      {...field}
                      invalid={!!fieldState.error}
                    />
                    <FormFeedback>{fieldState.error?.message}</FormFeedback>
                  </>
                )}
              />
            </FormGroup>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <Label for="site">{siteText}:</Label>
              <Controller
                control={form.control}
                name="site"
                render={({ field, fieldState }) => (
                  <>
                    <Input
                      InputLabelProps={{ shrink: true }}
                      type="text"
                      label="site"
                      variant="outlined"
                      margin="normal"
                      {...field}
                      invalid={!!fieldState.error}
                    />
                    <FormFeedback>{fieldState.error?.message}</FormFeedback>
                  </>
                )}
              />
            </FormGroup>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <Label for="email">{emailText}:</Label>
              <Controller
                control={form.control}
                name="email"
                render={({ field, fieldState }) => (
                  <>
                    <Input
                      InputLabelProps={{ shrink: true }}
                      type="text"
                      label="email"
                      variant="outlined"
                      margin="normal"
                      {...field}
                      invalid={!!fieldState.error}
                    />
                    <FormFeedback>{fieldState.error?.message}</FormFeedback>
                  </>
                )}
              />
            </FormGroup>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <Label for="type">{typeText}:</Label>
              <Controller
                name="type"
                control={form.control}
                defaultValue={typeOptions[0]}
                render={({ field }) => (
                  <>
                    <Input
                      InputLabelProps={{ shrink: true }}
                      type="select"
                      label="type"
                      variant="outlined"
                      margin="normal"
                      {...field}
                    >
                      {Object.values(typeOptions).map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </Input>
                  </>
                )}
              />
            </FormGroup>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <Label for="address">{addressText}:</Label>
              <Controller
                control={form.control}
                name="address"
                render={({ field, fieldState }) => (
                  <>
                    <Input
                      InputLabelProps={{ shrink: true }}
                      type="text"
                      label="address"
                      variant="outlined"
                      margin="normal"
                      {...field}
                      invalid={!!fieldState.error}
                    />
                    <FormFeedback>{fieldState.error?.message}</FormFeedback>
                  </>
                )}
              />
            </FormGroup>
          </Col>
          <Col lg={12}>
            <FormGroup>
              <Label for="observations">{observationsText}:</Label>
              <Controller
                control={form.control}
                name="observations"
                render={({ field, fieldState }) => (
                  <>
                    <Input
                      InputLabelProps={{ shrink: false }}
                      type="text"
                      label="observations"
                      variant="outlined"
                      margin="normal"
                      {...field}
                      invalid={!!fieldState.error}
                      style={{ height: '100px' }}
                    />
                    <FormFeedback>{fieldState.error?.message}</FormFeedback>
                  </>
                )}
              />
            </FormGroup>
          </Col>
        </Row>
      </Container>
      <Container className="companyFormFooter">
        <Row className="buttonGroup center">
          <Col sm={12}>
            {
              <>
                <Button
                  size="lg"
                  color="danger"
                  onClick={() => {
                    if (props.type === 'add') {
                      dispatch(setAddOrganizationForm(false));

                      if (
                        isMobile &&
                        document
                          .querySelector('.chatPanelContainer')
                          .classList.contains('hidden')
                      ) {
                        document
                          .querySelector('.chatPanelContainer')
                          .classList.remove('hidden');
                      }
                      dispatch(openChatTab());
                    }
                  }}
                >
                  {cancelText}
                </Button>{' '}
                <Button size="lg" color="primary">
                  {saveText}
                </Button>
              </>
            }
          </Col>
        </Row>
      </Container>
    </form>
  );
}
